import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { QueryState } from '../components/ui/QueryStateCard'

/** The guard on every `/settings*` route (MS-997 D2; spec §1-ctrl-vis): an
 * Admin sees the page, anyone else lands on Home — the prototype's
 * `applyRoute`, which sends a Controller who follows a link to Settings Home.
 * While the role is not known yet (the mount probe still answering, or a
 * profile cached without one) it waits, so an Admin is never bounced Home on
 * a stale cache. */
export function RequirePortalAdmin() {
  const { role, roleKnown } = useAuth()
  if (!roleKnown) return <QueryState state="pending" />
  return role === 'admin' ? <Outlet /> : <Navigate to="/" replace />
}
